<template>
    <page padding centered>
        <div class="row full-width">
            <div class="offset-xs-2 col-xs-8 col-md-4 offset-md-4">
                <div class="cover">
                    <div class="pacman">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>

                    </div>
                    <div class="col-12 text-center justify-center " style="z-index: 2000;position: relative;top: 60%;">

                        <p>Awaiting Payment Confirmation... Please try again later</p>
                        <q-btn color="primary" @click="$router.go()">Try Again</q-btn>
                    </div>

                </div>
            </div>

        </div>
    </page>
</template>

<script>
    import {QBtn} from 'quasar-framework'
    import axios from 'axios'
    import {mapGetters} from 'vuex'
    export default {
        layout: 'default',
        name: 'waiting',
        middleware:'auth',
        components:{
            QBtn
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
            }),
        },
        mounted(){
            if(this.$route.query._token)
            {
                // Save the token.
                this.$store.dispatch('auth/saveToken', {
                    token: this.$route.query._token,
                    remember: true
                })

                // Fetch the user.
                this.$store.dispatch('auth/fetchUser')

                this.$router.replace({query:{}});
            }

            if(this.user && this.user.subscription_status!=152)
                this.$router.push({name:'home'})

        },

    }
</script>

<style lang="stylus" scoped>
    .cover
        position fixed
        height 100%
        width 100%
        top 0
        left 0
        background #fff
        z-index 3000

    @keyframes rotate_pacman_half_up
        0%
            transform rotate(270deg)
        50%
            transform rotate(360deg)
        100%
            transform rotate(270deg)

    @keyframes rotate_pacman_half_down
        0%
            transform rotate(90deg)
        50%
            transform rotate(0deg)
        100%
            transform rotate(90deg)

    @keyframes pacman-balls
        75%
            opacity 0.7
        100%
            transform translate(-100px, -6.25px)

    .pacman
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        z-index 1024

        & > div:nth-child(2)
            animation pacman-balls 1s -0.99s infinite linear

        & > div:nth-child(3)
            animation pacman-balls 1s -0.66s infinite linear

        & > div:nth-child(4)
            animation pacman-balls 1s -0.33s infinite linear

        & > div:nth-child(5)
            animation pacman-balls 1s 0s infinite linear

        & > div:first-of-type
            width: 0px;
            height: 0px;
            border-right: 25px solid transparent;
            border-top: 25px solid #ff2222;
            border-left: 25px solid #ff2222;
            border-bottom: 25px solid #ff2222;
            border-radius: 25px;
            animation: rotate_pacman_half_up 0.5s 0s infinite;
            position: relative;
            left: -30px

        & > div:nth-child(2)
            width: 0px;
            height: 0px;
            border-right: 25px solid transparent;
            border-top: 25px solid #ff2222;
            border-left: 25px solid #ff2222;
            border-bottom: 25px solid #ff2222;
            border-radius: 25px;
            animation: rotate_pacman_half_down 0.5s 0s infinite;
            margin-top: -50px;
            position: relative;
            left: -30px;

        & > div:nth-child(3),
        & > div:nth-child(4),
        & > div:nth-child(5),
        & > div:nth-child(6)
            background-color #ff2222
            width 15px
            height 15px
            border-radius 100%
            margin 2px
            width 10px
            height 10px
            position absolute
            transform translate(0, -6.25px)
            top 25px
            left 70px
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/waiting.vue